module.exports = __webpack_public_path__ + "static/IMG_1233-2df1b55fd1f8707a450a2d37c850e5bb.jpg";